import { useQuery } from '@tanstack/react-query';
import PromptService from '../../../services/prompt-service';
import type { ConversationResponse } from '../../../types/agent';

const useGetPosts = (promptSlug: string | undefined) => {
  return useQuery<ConversationResponse>({
    queryKey: ['posts', promptSlug],
    queryFn: () => PromptService.getPosts(parseInt(promptSlug!)),
    enabled: !!promptSlug,
  });
};

export default useGetPosts;
